import React from 'react';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableTitle,
  TableWrapper,
} from '../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';

export const PerformanceTableSkeleton: React.FC = ({ children }) => {
  return (
    <TableWrapper mt="16">
      <TableTitle>
        <Text fontWeight={600} fontSize="h6">
          Performance Details
        </Text>
      </TableTitle>

      <TableHeader>
        <TableRow>
          <TableCell width="100%">&nbsp;</TableCell>
        </TableRow>
      </TableHeader>

      <TableBody>{children}</TableBody>
    </TableWrapper>
  );
};
